//******************************************************************************
// Test mode variables
//******************************************************************************
const inInTimesInTestMode = false; // checkRateInTime will return true, bypassing time window checks.
const MESSAGE_TIMEOUT = 10000;

//******************************************************************************
// Solution
//******************************************************************************
const hasClass = (className, el) => el.classList.contains(className)
const removeClass = (className, el) => el.classList.remove(className)
const addClass = (className, el) => el.classList.add(className)
const isDevSite = window.location.host === 'habitat-pet-supplies-dev.myshopify.com'

const isHomeShippingRendered = () => {
  const isSameDayDeliveryChecked = document.querySelector('#uber-delivery-input-radio')?.checked
  const isStandardDeliveryChecked = document.querySelector('#standard-shipping-input-radio')?.checked
  const result = !!(isSameDayDeliveryChecked || isStandardDeliveryChecked)
  return result
}

const fetchCart = async () => {
  const response = await fetch('/cart.js');
  return await response.json();
};

const updateCartAttributes = async (newAttributes) => {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: newAttributes })
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

const removeAllCartAttributes = async () => {
  const cart = await fetchCart()
  for (let key in cart.attributes) {
    if (cart.attributes.hasOwnProperty(key)) {
      cart.attributes[key] = "";
    }
  }
  try {
    const response = await updateCartAttributes(cart.attributes);
  } catch (error) {
    console.error("Error updating cart attributes:", error);
  }
}

removeAllCartAttributes()

const CLICK_AND_COLLECT_METHOD_NAME = "clickAndCollect"
const UBER_DELIVERY_METHOD_NAME = "uberDelivery"
const isCncAttribute = (name) => /^attributes\[(cnc-[a-zA-Z0-9-]+)\]$/.test(name);

const extractCncAttributeName = (name) => {
  const match = /^attributes\[(cnc-[a-zA-Z0-9-]+)\]$/.exec(name);
  return match ? match[1] : null;
};

const filterAndReformatCncPairs = (pairs) => pairs
  .filter(({ name }) => isCncAttribute(name))
  .map(({ name, value }) => ({ name: extractCncAttributeName(name), value }));

const convertCncPairsToObject = (formDataPairs) => {
  return filterAndReformatCncPairs(formDataPairs).reduce((obj, { name, value }) => {
    if (name) {
      obj[name] = value;
    }
    return obj;
  }, {});
};

const postJSON = async (url, data) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

const updateShopifyCartAttributes = async (formDataPairs) => {
  try {
    const attributes = convertCncPairsToObject(formDataPairs);
    const updatedCart = await postJSON('/cart/update.js', { attributes });
    console.log('Cart updated successfully:', updatedCart);
  } catch (error) {
    console.error('Error updating cart:', error);
  }
};

const extractFormData = (form) => {
  const formData = new FormData(form);
  const formPairs = Array.from(formData.entries()).map(entry => ({
    name: entry[0],
    value: entry[1]
  }));
  return formPairs;
}

const clickCheckoutButtonAndSubmitCheckoutForm = async () => {
  const formToSubmit = document.querySelector(".cart-container form[action='/cart']");
  const formDataPairs = extractFormData(formToSubmit);
  await updateShopifyCartAttributes(formDataPairs);
  const cartFormSubmitButton = formToSubmit.querySelector("button[type='submit']")
  cartFormSubmitButton.click()
}

const getInputElementValue = (elementId) => {
  const element = document.getElementById(elementId);
  return element ? element.value : null;
};

const cleanCartAttributes = async () => {
  const cncModeInputValue = getInputElementValue('cnc-mode-input');
  const validValues = ["home"];
  const shouldUpdateCart = (inputValue && !validValues.includes(inputValue))
  if (shouldUpdateCart) {
    await updateCartAttributes({
      "cnc-fulfilment-method": "",
      "Authority_to_leave": ""
    });
  }
};

const toggleCheckoutButtonBasedOnLocationStock = (cncOutletElement) => {
  $('#cnc-results-container').attr('old-data',$(cncOutletElement).val());
  if( $(cncOutletElement).attr('data-stock') == "false" ){
    $("#btn_checkout").attr('disabled','disabled');
    $(cncOutletElement).next().find('tbody tr').each(function(){
      if(parseInt($(cncOutletElement).attr('data-stock')) - parseInt($('ul[data-id='+$(cncOutletElement).attr('data-id')+'] .txtbox').val())  < 0){
        var headingHtml = `<span class="out-of-stock"><i class="fas fa-exclamation-circle"></i> Out of stock</span>`;
        $('ul[data-id='+$(cncOutletElement).attr('data-id')+'] .stock-status').html(headingHtml);
      }
      else{
        var headingHtml = `<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>`
        $('ul[data-id='+$(cncOutletElement).attr('data-id')+'] .stock-status').html(headingHtml);
      }
    })
  }
  else {
    $("#btn_checkout").removeAttr("disabled");
    var headingHtml = `<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>`
    $('ul .stock-status').html(headingHtml);
  }
}

const handleAuthorityToLeave = () => {
  if($('.alt-box').prop('checked') == true){
    $('input[name="attributes[Authority_to_leave]"]').val("Yes")
    if($('#cartSpecialInstructions').val() == ""){
      $('#cartSpecialInstructions').val("Authority to leave") ;
    }
  }
  else{
    $('input[name="attributes[Authority_to_leave]"]').val("No")
  }
}

const shouldCleanCartAttributes = (fulfilmentMethod, cart) => {
  const isClickAndCollectMethod = (fulfilmentMethod == CLICK_AND_COLLECT_METHOD_NAME)
  const isStoreSelected = (cart.attributes["cnc-fulfilment-method"] === "store")
  const isUberFulfilmentMethod = (fulfilmentMethod == UBER_DELIVERY_METHOD_NAME)
  const isHomeSelected = (cart.attributes["cnc-fulfilment-method"] === "home")
  const isStandardDeliveryChecked = $('#standard-shipping-input-radio').prop('checked')
  const shouldRemoveUberDeliveryProductToken = isUberFulfilmentMethod && (isHomeSelected || isStandardDeliveryChecked)
  const shouldRemoveClickAndCollectProductToken = isClickAndCollectMethod && isStoreSelected
  const result = (shouldRemoveClickAndCollectProductToken || shouldRemoveUberDeliveryProductToken)
  return result
}

const removeItemFromCart = async (cart, variantId) => {
  if(cart.items.find(item => item.variant_id == variantId)) {
    Shopify.changeItem(variantId, 0, function(cart) {
      cart.attributes = {}
      Shopify.updateQuickCart(cart);
    });
  }
}

const addItemToCart = async (productTokenUniqueVariantId) => {
  return new Promise((resolve, reject) => {
    Shopify.addItem(productTokenUniqueVariantId, 1, (response) => {
      response ? resolve() : reject(new Error('Failed to add item to cart'));
    });
  });
};

const isProductInCart = (cart, productTokenUniqueVariantId) =>
  cart.items.some(item => item.variant_id === productTokenUniqueVariantId);

const addOrRemoveProductToken = async (productTokenUniqueVariantId, fulfilmentMethod) => {
  try {
    const cart = await fetchCart();
    if (isProductInCart(cart, productTokenUniqueVariantId)) {
      if (shouldCleanCartAttributes(fulfilmentMethod, cart)) {
        await cleanCartAttributes();
      }
    } else {
      await addItemToCart(productTokenUniqueVariantId);
    }
    clickCheckoutButtonAndSubmitCheckoutForm();
  } catch (error) {
    console.error('Error handling product token:', error);
  }
};

const data = {
  "outlets": [
    {
      "name": "North Melbourne",
      "external_id": 4,
      "stock": {
        "7012688363550": 0,
        "28252210233443": 2,
        "32260278485091": 2
      },
      "contact": {
        "address1": "175 Macaulay Rd",
        "address2": "",
        "address3": "",
        "suburb": "North Melbourne",
        "state": "VIC",
        "postcode": "3051",
        "phone": "03 9326 4737",
        "email": "northmelbourne@habitatpets.com.au",
        "latitude": "-37.79711440",
        "longitude": "144.94017020"
      },
      "distance": 4
    },
    {
      "name": "Port Melbourne",
      "external_id": 5,
      "stock": {
        "7012688363550": 1,
        "28252210233443": 2,
        "32260278485091": 4
      },
      "contact": {
        "address1": "27 Crockford Street",
        "address2": "",
        "address3": "",
        "suburb": "Port Melbourne",
        "state": "VIC",
        "postcode": "3207",
        "phone": "03 96466481",
        "email": "portmelbourne@habitatpets.com.au",
        "latitude": "-37.83433940",
        "longitude": "144.94711670"
      },
      "distance": 5
    },
    {
      "name": "Burwood",
      "external_id": 3,
      "stock": {
        "7012688363550": 0,
        "28252210233443": 6,
        "32260278485091": 4
      },
      "contact": {
        "address1": "142 Highbury Rd",
        "address2": "",
        "address3": "",
        "suburb": "Burwood",
        "state": "VIC",
        "postcode": "3125",
        "phone": "03 9888 8536",
        "email": "burwood@habitatpets.com.au",
        "latitude": "-37.85554920",
        "longitude": "145.11116040"
      },
      "distance": 12
    },
    {
      "name": "Altona North",
      "external_id": 2,
      "stock": {
        "7012688363550": 1,
        "28252210233443": 4,
        "32260278485091": 4
      },
      "contact": {
        "address1": "1/174 Millers Rd",
        "address2": "",
        "address3": "",
        "suburb": "Altona North",
        "state": "VIC",
        "postcode": "3025",
        "phone": "03 9314 0234",
        "email": "altona@habitatpets.com.au",
        "latitude": "-37.83269810",
        "longitude": "144.84756560"
      },
      "distance": 13
    },
    {
      "name": "Chirnside Park",
      "external_id": 1,
      "stock": {
        "7012688363550": 2,
        "28252210233443": 4,
        "32260278485091": 4
      },
      "contact": {
        "address1": "1/286 Maroondah Hwy",
        "address2": "",
        "address3": "",
        "suburb": "Chirnside Park",
        "state": "VIC",
        "postcode": "3116",
        "phone": "03 9726 4302",
        "email": "chirnsidepark@habitatpets.com.au",
        "latitude": "-37.76750830",
        "longitude": "145.30134010"
      },
      "distance": 28
    }
  ]
}

const cartItemsTest = [
  {
    id: 7012688363550,
    quantity: 1
  },
  {
    id: 28252210233443,
    quantity: 1
  },
  {
    id: 32260278485091,
    quantity: 1
  }
]

const CHECK_STOCK_IN_STORE_HTML = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 616 512"><path fill="currentColor" d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zM516 464H100v-96h416zm-.2-144.2H100v-64.7c24-3.3 45.1-15.2 60.3-32.2 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 15.3 17 36.3 28.9 60.3 32.2zm47.9-133c-3.2 6.8-10.9 18.6-27 20.8-2.4.3-4.8.5-7.2.5-14.7 0-28.2-6.1-38.1-17.2L455.7 151 420 190.8c-9.9 11.1-23.5 17.2-38.1 17.2s-28.2-6.1-38.1-17.2L308 151l-35.7 39.8c-9.9 11.1-23.5 17.2-38.1 17.2-14.7 0-28.2-6.1-38.1-17.2L160.3 151l-35.7 39.8c-9.9 11.1-23.5 17.2-38.1 17.2-2.5 0-4.9-.2-7.2-.5-16-2.2-23.8-13.9-27-20.8-5-10.8-7.1-27.6 2.3-42.6L114.8 48h386.3l60.2 96.1c9.5 15.1 7.5 31.9 2.4 42.7z"></path></svg>Check Stock in Store`

const CLOSE_STOCK_CHECK_TEXT = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path></svg>Close Stock Check'

class ClickAndCollect {
  constructor(settings) {
    this.settings = settings;
    this.element = document.getElementById('cnc-container');
    this.resultsContainer = document.getElementById('cnc-results-container');
    this.resultsContainer.classList.add('cnc-results-container')
    this.mapContainer = document.getElementById('cnc-map-container');
    this.mapContainer.classList.add('cnc-map-container')
    this.messages = {};
    this.mapFocus = null;

    if (this.settings.enableMap && window.mapIsReady) {
      this.mapReady();
    }
  }
  addMessage(name, value, isError) {
    if (this.messages[name]) {
      this.removeMessage(name)
    }
    if (!this.messages[name]) {
      var message = new Message(value, isError);
      this.messages[name] = message;
      this.resultsContainer.appendChild(message.getElement());
    }
  }
  removeMessage(name) {
    if (this.messages[name]) {
      this.messages[name].getElement().outerHTML = '';
      delete this.messages[name];
    }
  }
  clearErrors() {
    for (let [name, message] of Object.entries(this.messages)) {
      if (message.isError) {
        this.removeMessage(name);
      }
    }
  }
  addAddressSearch() {
    this.search = new AddressSearch(this);
    this.mapContainer.appendChild(this.search.getElement());
  }
  addMap() {
    this.gmap = new GMap(this);
    this.mapContainer.appendChild(this.gmap.getElement());
    this.gmap.initMap();
  }
  mapReady() {
    this.addAddressSearch();
    this.addMap();
  }
  searchAddress(address) {
    var geocoder = new google.maps.Geocoder();
    var parent = this;
    geocoder.geocode({address: address}, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        parent.removeMessage('addressNotFound');
        parent.mapFocus = results[0].geometry.location;
        if (parent.results) {
          parent.results.setLocation(parent.mapFocus.lat(), parent.mapFocus.lng());
          parent.results.update();
          parent.gmap.show();
        }
      } else {
        if (parent.results) {
          parent.results.setLocation(null, null);
        }
        if(address != ""){
          parent.addMessage('addressNotFound', address + ' not found.', true);
        }
      }
    });
  }
  updateMap() {
    this.gmap.searchLocationsNear(this.mapFocus, this.results.getAllOutlets());
  }
}

class ClickAndCollectCart extends ClickAndCollect {
  constructor(settings) {
    super(settings);
    this.mode = null;
    this.modeButtons = {};
    this.outletContactFields = {};
    this.variantIds = settings.cartItems
      .map(item => item.variant_id)
      .filter(variantId => variantId != settings.clickAndCollectUniqueVariantId)
      .filter(variantId => variantId != settings.uberDeliveryUniqueVariantId)
      .filter(variantId => variantId != settings.uberDeliveryUniqueVariantId20)
      .filter(variantId => variantId != settings.uberDeliveryUniqueVariantId30)
    this.nativeMethod = []
    this.latitude = null;
    this.longitude = null;
    this.homeContainer = document.getElementById('cnc-home-container')
    this.homeContainer.classList.add('cnc-map-container')
    this.homeContainer.style.display = 'none';

    this.addModeButtons(['home', 'store']);
    this.addOutletContactFields(['address1', 'address2', 'address3', 'suburb', 'state', 'postcode', 'phone', 'email']);
    this.addOutletNameField();
    this.addOutletNumberField();
    this.addResults();
    this.addCartUpdateListener();
    this.setMode('store');
    this.updateCollectionAbility();
    this.initUber()

    document.addEventListener('updateFieldsClickAndCollect',() =>{
      this.updateContactFields()
    })

    document.addEventListener('updateShippingCalculator', async() => {
      const value = $('.shipping-search-input').val()
      if (value) {
        await this.getShippingRates(value)
      }
    })

    if (!this.settings.enableMap) {
      this.results.update();
    }
  }
  setLocation(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  }

  addModeButtons(values) {
    for (var value of values) {
      var button = new ModeButton(this, value);
      this.modeButtons[value] = button;
      this.element.appendChild(button.getElement());
      this.element.appendChild(button.getLabel());
    }
    var modeInput = document.createElement('input');
    modeInput.id = `cnc-mode-input`;
    modeInput.type = 'hidden';
    modeInput.name = 'attributes[cnc-fulfilment-method]';
    modeInput.value = 'home';
    this.element.appendChild(modeInput);
    this.modeInput = modeInput;
  }
  addOutletContactFields(fieldNames) {
    for (var fieldName of fieldNames) {
      var field = new OutletContactField(fieldName);
      this.outletContactFields[fieldName] = field;
      this.element.appendChild(field.getElement());
    }
  }
  addOutletNumberField() {
    var field = new OutletContactField('number', 'cnc-outlet', 'attributes[cnc-outlet]');
    this.outletNumberField = field;
    this.element.appendChild(field.getElement());
  }
  addOutletNameField() {
    var field = new OutletContactField('name', 'cnc-store-name', 'attributes[cnc-store-name]');
    this.outletNameField = field;
    this.element.appendChild(field.getElement());
  }
  addResults() {
    this.results = new CartResults(this, this.settings.apiPrefix, this.settings.subdomain);
    this.resultsContainer.appendChild(this.results.getElement());
  }
  getMode() {
    return this.mode;
  }
  setMode(mode) {

    if (mode === this.mode) {
      return;
    }
    this.mode = mode;
    this.modeInput.value = mode;
    for (let [key, modeButton] of Object.entries(this.modeButtons)) {
      if (modeButton.getValue() === mode) {
        modeButton.select();
      }
      modeButton.updateDisplay();
    }
    this.clearErrors()
    $('ul .stock-status').html('<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>');
    if (this.mode === 'home') {
      if (this.mapContainer) {
        this.mapContainer.style.display = 'none';
      }
      if (this.homeContainer) {
        this.homeContainer.style.display = '';
      }
      this.results.hide();
      this.results.selectNone();
      for (let [key, contactField] of Object.entries(this.outletContactFields)) {
        contactField.clear();
      }
      this.outletNameField.clear();
      let self = this;
      Shopify.getCart(function(cart){
        for(let item of cart.items){
          if(item.grams > 998999){
            $("#btn_checkout").attr('disabled','disabled');
            self.addMessage('weight','Your cart contains in store only items these are only available for Same Day Delivery or Click and Collect', true);
            return;
          }
        }
      })
    } else if (this.mode === 'store') {
      if (this.mapContainer) {
        this.mapContainer.style.display = '';
      }
      if (this.homeContainer) {
        this.homeContainer.style.display = 'none';
      }
      this.resetShippingRate()
      this.results.show();
      this.results.selectFirst();
      this.updateContactFields();
    }
    this.updateCheckoutButton();
  }
  updateCollectionAbility() {
    if (this.results.doOutletsExist() || this.settings.enableMap) {
      this.modeButtons['store'].show();
      this.removeMessage('noLocations');
    } else {
      this.setMode('home');
      this.modeButtons['store'].hide();
      this.addMessage('noLocations', 'No locations available for store pickup.', true);
    }
  }
  updateContactFields() {
    var selectedOutlet = this.results.getSelectedOutlet();
    if (selectedOutlet) {
      for (let [key, contactField] of Object.entries(this.outletContactFields)) {
        contactField.setValue(selectedOutlet.getContact()[key]);
      }
      this.outletNameField.setValue(selectedOutlet.getName());
      this.outletNumberField.setValue(selectedOutlet.getExternalId());
    }
  }

  updateCheckoutButton() {
    var checkoutButton = document.querySelector('button[name="checkout"]') || document.querySelector('input[name="checkout"]');
    checkoutButton = document.querySelector('#btn_checkout')
    if (checkoutButton) {
      this.checkoutButton = checkoutButton;
      if (this.mode === 'store' && !this.results.areOutletsAvailable()) {
        checkoutButton.disabled = true;
        $('#btn_checkout').attr('disabled','disabled')
        if (this.results.isLoaded()) {
          if (this.settings.enableMap && this.results.count() < 1) {
            this.removeMessage('pleaseUpdateCart');
            this.addMessage('pleaseSearchAgain', 'Sorry, no pickup locations are available in this area. Please search again or choose Home Delivery.', true);
          } else {
            this.removeMessage('pleaseSearchAgain');
            this.addMessage('pleaseUpdateCart', 'Sorry, no pickup locations are available for all items in your cart. Please remove items from your cart or choose Home Delivery.', true);
          }
        }
      } else {
        if(isHomeShippingRendered()){
          checkoutButton.disabled = true;
        }
        else {
          checkoutButton.disabled = false;
          this.removeMessage('pleaseUpdateCart');
          this.removeMessage('pleaseSearchAgain');
        }
      }
    }
  }
  addCartUpdateListener() {
    var parent = this;
    var cartTable = document.getElementById('CartProducts');
    if (cartTable) {
      cartTable.addEventListener('DOMSubtreeModified', (event) => {
        if (parent.results.isLoaded()) {
          parent.results.update();
        }
      });
    }
  }

  checkProductAvailableInStore (stock, items) {
    return items.every(item => stock[item.id] >= item.quantity)
  }

  checkRateInTime(isTestMode = false) {
    if (isTestMode) {
      console.warn("Test mode active: checkRateInTime will return true, bypassing time window checks.");
      return true
    }
    const melbourneTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Melbourne"})
    const isWeekday = (d = new Date(melbourneTime)) => d.getDay() % 6 !== 0;
    const getMinutesDiffBetweenDates = (dateInitial, dateFinal) => (dateFinal - dateInitial) / (1000 * 60)
    const currentDayTime = new Date(melbourneTime)

    if (isWeekday) {
      currentDayTime.setHours(16)
      currentDayTime.setMinutes(0)
      const diff = getMinutesDiffBetweenDates(new Date(melbourneTime), currentDayTime)

      if (diff > 0) {
        return true
      } else {
        return false
      }
    } else {
      currentDayTime.setHours(15)
      currentDayTime.setMinutes(0)
      const diff = getMinutesDiffBetweenDates(new Date(melbourneTime), currentDayTime)

      if (diff > 0) {
        return true
      } else {
        return false
      }
    }
  }

  renderShippingRates(otherRates = []) {
    let items = [];
    if (this.nativeMethod[0]) {
      items = [this.nativeMethod[0], ...otherRates];
    } else {
      items = [...otherRates];
    }

    // Filter out non Same Day Delivery methods
    if (window.cartHasStoreOnlyItems) {
      items = items.filter(rate =>
        rate.name.includes('Same Day Delivery')
      );
    }

    if (items && items.length > 0) {
      this.renderShippingRatesResults(items);
    } else {
      this.addMessage('uberMessage', '<div>No stores are available for delivery to your area</div>', true);
    }
  }

  renderShippingRatesResults (items) {
    const sameDayRateKey = '2hr Same Day Delivery'
    let html = ''
    for (let i = 0; i < items.length; i++){

      const selectInputIfIsFirstRate = (rateIndex) => {
        if (rateIndex==0) return ' checked'
        else return ''
      }
      let name = items[i].name
      let price = items[i].price
      if(name !== 'Click & Collect') {
        html+= '<li>';
        html+= items[i].name !== sameDayRateKey ?
            `<input type="radio" name="shipping-method" id="standard-shipping-input-radio" value="standard-shipping"${selectInputIfIsFirstRate(i)}>` :
            `<input type="radio" name="shipping-method" id="uber-delivery-input-radio" value="uber-delivery"${selectInputIfIsFirstRate(i)}>`
        html+= '<span class="rate-name">'+ name +'</span>';
        html+= '<span class="rate-price">$'+price+'</span>';
        html+= '</li>';
      }
    }
    $('#data-rates').append(html);
  }

  resetShippingRateResults () {
    $('#data-rates').empty();
  }

  resetShippingRate () {
    this.nativeMethod = []
    $('#data-rates').html('')
    $('.shipping-search-input').val('')
  }

  checkRateAvailable (outlets) {
    const SAME_DAY_DELIVERY_RADIUS = 20
    const cartItems = isDevSite ? cartItemsTest : this.settings.cartItems
    const compareByDistance = (a, b) => a.distance - b.distance
    const doesOutletHasCartItem = (outlet, cartItem) =>
      outlet.stock[cartItem.id] >= cartItem.quantity
    const doesOutletHasStock = (outlet, cartItems) =>
      cartItems.every(cartItem => doesOutletHasCartItem(outlet, cartItem))
    outlets = outlets.sort(compareByDistance);
    outlets = outlets.filter(outlet => outlet.distance <= SAME_DAY_DELIVERY_RADIUS);
    outlets = outlets.filter(outlet => doesOutletHasStock(outlet, cartItems))
    const closestOutlet = outlets[0]
    const isInTimes = this.checkRateInTime(inInTimesInTestMode)
    if ((closestOutlet && isInTimes)) {
      closestOutlet.distancePrice = 10;
      if (closestOutlet.distance > 10 && closestOutlet.distance <= 15) {
        closestOutlet.distancePrice = 20;
      } else if (closestOutlet.distance > 15 && closestOutlet.distance <= 20) {
        closestOutlet.distancePrice = 30;
      }
      const sameDayRate = [
        {
          name: "2hr Same Day Delivery",
          price: closestOutlet.distancePrice,
        },
      ];
      this.renderShippingRates(sameDayRate)
      $('#cnc-mode-input').val('store')
      window.closestOutlet = closestOutlet
    } else {
      this.renderShippingRates()
    }
  }

  getRatesTest () {
    this.checkRateAvailable(data.outlets)
  }

  getRates () {
    this.resetShippingRateResults()
    this.removeMessage('uberMessage')
    this.removeMessage('addressNotFound')
    let url = `https://${this.settings.apiPrefix}/api/shopify_stores/${this.settings.subdomain}/outlets?variant_ids=${this.variantIds.join()}`;

    //Do not search for inventory of token products
    this.settings.cartItems = this.settings.cartItems
      .filter(cartItem => cartItem.variant_id != this.settings.clickAndCollectUniqueVariantId)
      .filter(cartItem => cartItem.variant_id != this.settings.uberDeliveryUniqueVariantId)
      .filter(cartItem => cartItem.variant_id != this.settings.uberDeliveryUniqueVariantId20)
      .filter(cartItem => cartItem.variant_id != this.settings.uberDeliveryUniqueVariantId30)

    for (let cartItem of this.settings.cartItems) {
      url += `&qty-${cartItem.variant_id}=${cartItem.quantity}`;
    }
    if (this.latitude && this.longitude) {
      url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
    }
    const self = this

    fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.outlets && !json.outlets.length) {
          self.addMessage('uberMessage', '<div>Same day delivery not available in your area</div>', true);
        }
        self.checkRateAvailable(json.outlets);
      })
      .catch(function(error) {
        self.resetShippingRate()
        self.addMessage('uberMessage', '<div>Same day delivery not available in your area</div>', true)
      });
  }

  async getShippingRates(postcode) {
    $('.shipping-search-button').attr("disabled", true)
    const self = this
    const cart = await fetchCart()
    window.cartHasStoreOnlyItems = cart.items.some(item => item.grams > 998999)
    const province = getProvinceFromZipCode(postcode)
    self.removeMessage('suburbError')
    let suburbs = []

    try {
      // Attempt to get suburbs from API
      const response = await getSuburbsFromPostcode(postcode)
      suburbs = response.suburbs
      if (!suburbs || suburbs.length === 0) {
        throw new Error('Suburbs not found')
      }
    } catch (e) {
      self.addMessage('suburbError', 'Postcode not found. Continue to checkout to calculate shipping costs.', true)
      $('.shipping-search-button').attr("disabled", false)
      // Turn on submit button to pass to checkout.
      setTimeout(() => {
        self.removeMessage('suburbError');
      }, MESSAGE_TIMEOUT); // Remove message after timeout
      $('#btn_checkout').removeAttr('disabled')
      return
    }

    const country = $('#address_country').val();
    let shippingRatesFound = false;

    for (const suburb of suburbs) {
      const data = {
        country,
        province,
        city: suburb,
        zip: postcode
      };

      try {
        const response = await $.ajax({
          type: 'GET',
          url: '/cart/shipping_rates.json',
          data: Shopify.param({ 'shipping_address': data }),
          dataType: 'json',
        });

        if (response.shipping_rates && response.shipping_rates.length > 0) {
          // If we get here, shipping rates were found
          shippingRatesFound = true
          self.nativeMethod = response.shipping_rates;
          self.searchUberAddress(postcode);

          $('.shipping-search-button').attr("disabled", false)
          $('.shipping-search-input').blur();

          break; // Exit the loop since we have found shipping rates
        } else {
          // Shipping rates array is empty, continue to next suburb
          continue
        }
      } catch (error) {
        // Continue to next suburb
      }

    }

    if (!shippingRatesFound) {
      // Handle case where no shipping rates found for any suburb
      const errorText = 'Shipping rates not found for the given postcode and suburbs'
      self.addMessage('uberMessage', `<div>${errorText}</div>`, true)
      self.resetShippingRate()
      $('.shipping-search-button').attr("disabled", false)
    }

    if (self.mode === "home" && isHomeShippingRendered()) {
      $("#btn_checkout").removeAttr("disabled");
    }
  }

  searchUberAddress(address) {
    address = `Australia ${address}`
    var geocoder = new google.maps.Geocoder();
    var parent = this;
    parent.removeMessage('addressNotFound');
    geocoder.geocode({address: address}, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        parent.removeMessage('addressNotFound');
        parent.mapFocus = results[0].geometry.location;
        parent.setLocation(parent.mapFocus.lat(), parent.mapFocus.lng());
        if (!isDevSite) {
          parent.getRates()
        } else {
          parent.getRatesTest()
        }
      } else {
        parent.setLocation(null, null);
        if(address != ""){
          parent.addMessage('addressNotFound', address + ' not found.', true);
        }
      }
    });
  }

  initUber() {
    this.search = new AddressHomeSearch(this);
    this.homeContainer.appendChild(this.search.getElement());
  }
}

class ClickAndCollectProduct extends ClickAndCollect {
  constructor(settings, initialVariantId) {
    super(settings);
    this.initialVariantId = initialVariantId;
    this.addCheckStockButton();
    this.addResults();
    this.addVariantEventListener();
    if (this.mapContainer) {
      this.mapContainer.style.display = 'none';
    }
  }
  addCheckStockButton() {
    var checkStockButton = new CheckStockButton(this);
    this.element.appendChild(checkStockButton.getElement());
  }
  addResults() {
    var results = new ProductResults(this, this.settings.apiPrefix, this.settings.subdomain, this.initialVariantId);
    this.results = results;
    this.resultsContainer.appendChild(this.results.getElement());
  }
  addVariantEventListener() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      form.addEventListener('click', (event) => {
        if (this.results.isLoaded()) {
          this.results.unload();
          this.clearErrors();
          if (this.settings.enableMap) {
            this.hideClickAndCollect()
            this.gmap.hide();
          }
        }
      });
    }
  }
  hideClickAndCollect () {
    this.mapContainer.style.display = 'none';
    this.resultsContainer.style.display = 'none';
  }
  showClickAndCollect () {
    this.mapContainer.style.display = '';
    this.resultsContainer.style.display = '';
  }
  reveal() {
    if (this.settings.enableMap) {
      this.showClickAndCollect()
    } else {
      this.results.fetch();
    }
  }
  resultsLoaded() {
    if (this.settings.enableMap && this.results.count() < 1) {
      this.addMessage('pleaseSearchAgain', 'Sorry, no pickup locations are available in this area.', true);
    } else {
      this.removeMessage('pleaseSearchAgain');
    }
  }
}

class Renderable {
  getElement() {
    return this.element;
  }
  show() {
    this.element.style.display = '';
    if (this.label) {
      this.label.style.display = '';
    }
  }
  hide() {
    this.element.style.display = 'none';
    if (this.label) {
      this.label.style.display = 'none';
    }
  }
}

class AddressSearch extends Renderable {
  constructor(cnc) {
    super();
    this.cnc = cnc;
    this.createElement();
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.classList.add('cnc-address-search');
    this.element.id = 'cnc-address-search';
    this.label = document.createElement('p');
    this.label.innerHTML = 'Search for a location to pick up your order:';
    this.element.appendChild(this.label);
    this.input = document.createElement('input');
    this.input.type = 'search';
    this.input.maxLength = 4;
    this.input.classList.add('cnc-address-search-input');
    this.input.placeholder = 'Enter Postcode';
    this.element.appendChild(this.input);
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add('cnc-address-search-button');
    this.button.innerHTML = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg><span class="cnc-address-search-label">Search</span>';
    this.element.appendChild(this.button);
    this.button.addEventListener('click', (event) => {
      if (this.input.value !== '') {
        this.cnc.searchAddress(`Postcode ${this.input.value}`);
      }
    });
    var parent = this;
    this.input.addEventListener('keyup', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        parent.cnc.searchAddress(`Postcode ${parent.input.value}`);
        return false;
      }
      const inputVal = document.querySelector('#cnc-address-search .cnc-address-search-input');
      const inputValContent= inputVal.value;
      if (inputValContent.length === 4) {
        parent.cnc.searchAddress(`Postcode ${parent.input.value}`);
      }
    });
    this.input.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        return false;
      }
    });
  }
}

class AddressHomeSearch extends Renderable {
  constructor(cnc) {
    super();
    this.cnc = cnc;
    this.createElement();
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.classList.add('home-address-search');
    this.element.id = 'home-address-search';
    this.label = document.createElement('p');
    this.label.style.marginBottom = '10px';
    this.label.innerHTML = 'Enter postcode for postage estimate:';
    this.element.appendChild(this.label);
    this.input = document.createElement('input');
    this.input.type = 'search';
    this.input.classList.add('shipping-search-input');
    this.input.placeholder = 'Enter Postcode';
    this.element.appendChild(this.input);
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add('shipping-search-button');
    this.button.classList.add('cnc-address-search-button');
    this.button.innerHTML = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg><span class="cnc-address-search-label">Search</span>';
    this.checkbox = document.createElement('div')
    this.checkbox.classList.add('checkcontainer');
    this.checkbox.innerHTML = '<input class="alt-box" type="checkbox"><span class="checkmark"></span>Authority to leave<a target="_blank" href="/pages/shipping-returns"> more info</a>'
    this.rates = document.createElement('div')
    this.rates.id = 'data-rates'
    // Looking for Same Day Delivery
    this.dayDelivery = document.createElement('div')
    this.dayDelivery.classList.add('day-delivery');
    this.dayDelivery.innerHTML = this.createHtmlDelivery()
    this.element.appendChild(this.button);
    this.element.appendChild(this.checkbox);
    this.element.appendChild(this.rates)
    this.element.appendChild(this.dayDelivery)
    this.button.addEventListener('click', (event) => {
      if (event.isTrusted) {
        this.cnc.getShippingRates(this.input.value);
      }
    });

    var parent = this;
    let lastTriggerTime = 0;
    const TRIGGER_DELAY = 1000;
    this.input.addEventListener('keyup', function(event) {
      const now = Date.now();
      const inputVal = document.querySelector('#home-address-search .shipping-search-input');
      const inputValContent = inputVal.value;
      const keyUpWasEnter = event.key === 'Enter';
      const keyUpWasADigit = /^\d$/.test(event.key);
      const isPostcodeComplete = inputValContent.length === 4;

      parent.cnc.removeMessage('suburbError')

      if (keyUpWasEnter || (keyUpWasADigit && isPostcodeComplete)) {
        if (now - lastTriggerTime < TRIGGER_DELAY) {
          return false; // Prevent rapid successive triggers
        }
        event.preventDefault();
        parent.cnc.getShippingRates(parent.input.value);
        lastTriggerTime = now;
        return false;
      }
    });

    this.input.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        return false;
      }
    });

    const closeTooltip = this.element.querySelector('.wrap-content-delivery .close')
    const overlay = this.element.querySelector('.wrap-content-delivery .overlay')
    const openTooltip = this.element.querySelector('.wrap-content-delivery .open')
    const markerCard = this.element.querySelector('.wrap-content-delivery .marker__card')

    closeTooltip.addEventListener('click', function(e) {
      markerCard.style.display = "none"
      overlay.style.display = "none"
    })
    openTooltip.addEventListener('click', function(e) {
      markerCard.style.display = "block"
      overlay.style.display = "block"
    })
    overlay.addEventListener('click', function(e) {
      markerCard.style.display = "none"
      overlay.style.display = "none"
    })
  }
  createHtmlDelivery(){
    return `<div class="wrap-content-delivery">
      <p class="heading">Looking for Same Day Delivery?</p>
      <div class="markers" tabindex="0"">
        <svg class="open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#01AF67" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 7.5H8V11H8.5" stroke="#01AF67" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z" fill="#01AF67"/>
        </svg>
        <div class="overlay">
        </div>
        <div id="box-delivery" class="arrow_box marker__card">
          <svg class="close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.5 3.5L3.5 12.5" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.5 12.5L3.5 3.5" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
            <p class="dayDeliveryTitle">${this.cnc.settings.dayDeliveryTitle}</p>
            <p>${this.cnc.settings.dayDeliveryContent}</p>
          </div>
        </div>
      </div>`
  }
}

class GMap extends Renderable {
  constructor(cnc) {
    super();
    this.cnc = cnc;
    this.gmap;
    this.markers = [];
    this.infoWindow;
    this.locationSelect;
    this.mapInitialised = false;
    this.createElement();
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.id = 'cnc-map';
    this.hide();
  }
  initMap() {
    var sydney = {lat: -33.863276, lng: 151.107977};
    this.gmap = new google.maps.Map(this.element, {
      center: sydney,
      zoom: 11,
      zoomControl: true,
      mapTypeId: 'roadmap'
    });
    this.infoWindow = new google.maps.InfoWindow();
    this.mapInitialised = true;
  }
  clearLocations() {
    this.infoWindow.close();
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers.length = 0;
  }
  searchLocationsNear(center, outlets) {
    this.clearLocations();
    var bounds = new google.maps.LatLngBounds();
    for (let [name, outlet] of Object.entries(outlets)) {
      var bounds = new google.maps.LatLngBounds();
      var address = outlet.getAddressHtml();
      var distance = 0;
      var latlng = new google.maps.LatLng(
          parseFloat(outlet.getContact().latitude),
          parseFloat(outlet.getContact().longitude)
      );
      this.createMarker(latlng, name, address, outlet.data.distance);
      bounds.extend(latlng);
    }
    if (outlets.length >= 1) {
      this.gmap.fitBounds(bounds);
      var zoom = this.gmap.getZoom();
      this.gmap.setZoom(zoom > 10 ? 10 : zoom);
    } else {
      this.gmap.setCenter(center);
    }
  }
  createMarker(latlng, name, address, distance) {
    var html = `<b>${name}</b><br>`;
    if (distance) {
      html += distance + 'km<br>';
    }
    html += address;
    var marker = new google.maps.Marker({
      map: this.gmap,
      position: latlng
    });
    var parent = this;
    google.maps.event.addListener(marker, 'click', function() {
      parent.infoWindow.setContent(html);
      parent.infoWindow.open(parent.gmap, marker);
    });
    this.markers.push(marker);
  }
}

class ModeButton extends Renderable {
  removeInputsOnSelect
  constructor(cnc, value) {
    super();
    this.cnc = cnc;
    this.value = value;
    this.createElement();
    this.createLabel();
    this.element.addEventListener('change', (event) => {
      this.cnc.setMode(this.element.value);
    });
    this.updateDisplay();
    this.removeInputsOnSelect = (event) => {
      if (event && event.target && event.target.id && event.target.id.includes('home')) {
        const cncOutletEl = document.querySelector('input[name="attributes[cnc-outlet]"]')
        if (cncOutletEl) {
          // synchronous does not update the value as expected
          setTimeout(() => {
            cncOutletEl.value = null
          })
        }
      }
    }
  }
  select() {
    if (!this.element.checked) {
      this.element.checked = true;
    }
  }
  updateDisplay() {
    if (this.element.checked) {
      this.label.classList.add('btn--secondary');
    } else {
      this.label.classList.remove('btn--secondary');
    }
  }
  createElement() {
    this.element = document.createElement('input');
    this.element.id = `cnc-${this.value}-radio`;
    this.element.type = 'radio';
    this.element.value = this.value;
    this.element.name = 'cnc-mode-radio';
    this.element.addEventListener('input', (e) => {this.removeInputsOnSelect(e)})
  }
  createLabel() {
    this.label = document.createElement('label');
    this.label.setAttribute('for', `cnc-${this.value}-radio`);
    this.label.classList.add('btn');
    if (this.value === 'home') {
      this.label.classList.add('home');
      this.label.innerHTML = '<i class="fas fa-globe-americas"></i><br>Home Delivery';
    } else if (this.value === 'store') {
      this.label.classList.add('store');
      this.label.style.display = 'none';
      this.label.innerHTML = '<i class="fas fa-store"></i><br>Click & Collect';
    }
  }
  getLabel() {
    return this.label;
  }
  getValue() {
    return this.element.value;
  }
}

class CheckStockButton extends Renderable {
  constructor(cncProduct) {
    super();
    this.cncProduct = cncProduct;
    this.createElement();
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      if (hasClass('active', this.element)) {
        this.element.innerHTML = CHECK_STOCK_IN_STORE_HTML
        removeClass('active', this.element)
        this.cncProduct.hideClickAndCollect()
        return
      }
      this.element.innerHTML = CLOSE_STOCK_CHECK_TEXT
      addClass('active', this.element)
      var addToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
      if (addToCartButton && addToCartButton.disabled) {
        this.cncProduct.addMessage('productUnavailable', 'Product variant is unavailable.', true);
      } else {
        this.cncProduct.removeMessage('productUnavailable');
        this.cncProduct.reveal();
      }
    });
  }
  createElement() {
    this.element = document.createElement('button');
    this.element.innerHTML = CHECK_STOCK_IN_STORE_HTML;
    this.element.classList.add('btn', 'btn--check-in-stock');
  }
}

class Outlet extends Renderable {
  constructor(cnc, data, cartItems) {
    super();
    this.cnc = cnc;
    this.data = data;
    this.createAvailabilityTable(cartItems);
    this.createElement();
    this.createLabel();
    this.element.addEventListener('change', (event) => {
      if (this.cnc.settings.template === 'product') {
        return
      }
      cnc.updateContactFields();
    });
  }
  getAvailability() {
    return this.availabilityTable && this.availabilityTable.isOutletAvailable();
  }
  getAvailabilityTable() {
    return this.availabilityTable;
  }
  createAvailabilityTable(cartItems) {
    this.availabilityTable = new AvailabilityTable(
        cartItems,
        this.data.stock,
        true,
        this.cnc.settings.showQuantity
    );
  }
  isSelected() {
    return this.element.checked;
  }
  select() {
    this.element.checked = true;
  }
  deselect() {
    this.element.checked = false;
  }
  getContact() {
    return this.data.contact;
  }
  getName() {
    return this.data.name;
  }
  getExternalId() {
    return this.data.external_id;
  }
  createElement() {
    this.element = document.createElement('input');
    this.element.id = `cnc-outlet-${this.data.external_id}`;
    this.element.type = 'radio';
    this.element.name = 'cnc-outlet-element';
    this.element.value = this.data.external_id;
    this.element.setAttribute('data-stock',this.getAvailability());
    this.element.classList.add('cnc-outlet');
  }
  createLabel() {
    this.label = document.createElement('label');
    this.label.setAttribute('for', `cnc-outlet-${this.data.external_id}`);
    this.label.classList.add('cnc-outlet-label');
    var storeDetails = document.createElement('div');
    storeDetails.classList.add('cnc-store-details');
    storeDetails.insertAdjacentHTML('beforeend', `<h4 class="store-name">${this.data.name}</h4>`);
    if (this.data.distance) {
      storeDetails.insertAdjacentHTML('beforeend', '<span class="store-distance">'+this.data.distance + 'km</span> <i class="fa fa-angle-down"></i>');
    }
    storeDetails.insertAdjacentHTML('beforeend', this.getAddressHtml());
    this.label.appendChild(storeDetails);
    this.label.appendChild(this.getAvailabilityTable().getElement());
  }
  getAddressHtml() {
    var address = document.createElement('span');
    address.id = `cnc-outlet-${this.data.external_id}-address`;
    var innerHtml = '';
    innerHtml += "<h4 class='name-address'>Habitat "+this.data.name+"</h4>";
    if (this.data.contact.address1) {
      innerHtml += "<p class='store-address1'>"+this.data.contact.address1 + '</p>';
    }
    if (this.data.contact.address2) {
      innerHtml += "<p class='store-address2'>"+this.data.contact.address2 + '</p>';
    }
    if (this.data.contact.address3) {
      innerHtml += "<p class='store-address3'>"+this.data.contact.address3 + '</p>';
    }
    if (this.data.contact.suburb) {
      innerHtml += "<p class='store-address4'>"+ this.data.contact.suburb + '&nbsp;'  + '</p>';
    }
    if (this.data.contact.state) {
      innerHtml += "<p class='store-address5'>"+this.data.contact.state + ',&nbsp</p>';
    }
    if (this.data.contact.postcode) {
      innerHtml += "<p class='store-address6'>"+this.data.contact.postcode + '</p>';
    }
    return innerHtml;
  }
  getLabel() {
    return this.label;
  }
}

class ProductOutlet extends Outlet {
  constructor(cnc, data, cartItems) {
    super(cnc, data, cartItems);
  }
  createAvailabilityTable(cartItems) {
    this.availabilityTable = new AvailabilityTable(
        cartItems,
        this.data.stock,
        false,
        this.cnc.settings.showQuantity
    );
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.classList.add('cnc-outlet');
  }
  createLabel() {
    this.label = document.createElement('div');
    this.label.classList.add('cnc-outlet-label');
    this.label.classList.add('cnc-product-outlet-label');
    var storeDetails = document.createElement('div');
    storeDetails.classList.add('cnc-store-details');
    storeDetails.insertAdjacentHTML('beforeend', `<strong>${this.data.name}</strong><br>`);
    storeDetails.insertAdjacentHTML('beforeend', this.getAddressHtml());
    this.label.appendChild(storeDetails);
    this.label.appendChild(this.getAvailabilityTable().getElement());
  }
}

class AvailabilityTable extends Renderable {
  constructor(cartItems, stockLevels, showTable, showQuantity) {
    super();
    this.products = [];
    this.showTable = showTable;
    this.showQuantity = showQuantity;
    this.updateProducts(cartItems, stockLevels);
    this.createElement();
  }
  updateProducts(cartItems, stockLevels) {
    if (cartItems && cartItems.length) {
      for (let cartItem of cartItems) {
        var product = Object.assign({}, cartItem);
        product.outletStock = stockLevels[cartItem.variant_id];
        this.products.push(product);
      }
    } else {
      for (let [variantId, stockLevel] of Object.entries(stockLevels)) {
        var product = {
          variant_id: variantId,
          outletStock: stockLevel,
          quantity: 1
        };
        this.products.push(product);
      }
    }
  }
  isOutletAvailable() {
    for (let product of this.products) {
      if (!this.isProductAvailable(product)) {
        return false;
      }
    }
    return true;
  }
  isProductAvailable(product) {
    return product.outletStock >= product.quantity;
  }
  createElement() {
    if (this.showTable) {
      this.createTableElement();
    } else {
      this.createTextElement();
    }
  }
  createTableElement() {
    this.element = document.createElement('table');
    this.element.classList.add('cnc-availability-table');
    if (this.isOutletAvailable()) {
      var headingHtml = `<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>`;
    } else {
      let stock = false;
      var headingHtml;
      this.products.find(function(product){
        if(product.outletStock >= product.quantity){
          stock = true;
        }
      })
      if(stock){
        headingHtml = `<span class="out-of-stock"><i class="fas fa-exclamation-circle"></i> Partial stock</span>`;
      }else{
        headingHtml = `<span class="out-of-stock"><i class="fas fa-exclamation-circle"></i> Out of stock</span>`;
      }
    }
    var head = document.createElement('thead');
    head.insertAdjacentHTML('beforeend', headingHtml);
    head.insertAdjacentHTML('beforeend', '<tr><th>Product</th><th>Qty</th><th>Available</th></tr>');
    this.element.appendChild(head);
    var body = document.createElement('tbody');
    for (let product of this.products) {
      if (this.isProductAvailable(product)) {
        var productTitle = product.title;
      } else if (product.outletStock > 0) {
        var productTitle = `<span class="strike">${product.title}</span> <span class="cnc-negative-text">(Insufficient stock)</span>`;
      } else {
        var productTitle = `<span class="strike">${product.title}</span> <span class="cnc-negative-text">(Out of stock)</span>`;
      }
      if (this.showQuantity) {
        var productAvailable = this.isProductAvailable(product)
            ? `<span class="cnc-positive-text"><strong>${product.outletStock}</strong></span>`
            : `<span class="cnc-negative-text"><strong>${product.outletStock}</strong></span>`;
      } else {
        var productAvailable = this.isProductAvailable(product)
            ? '<i class="fas fa-check-circle cnc-positive-text"></i>'
            : '<i class="fas fa-times-circle cnc-negative-text"></i>';
      }
      body.insertAdjacentHTML('beforeend', `<tr data-id="${product.id}" data-stock="${product.outletStock}" ><td>${productTitle}</td><td>${product.quantity}</td><td>${productAvailable}</td></tr>`);

    }
    this.element.appendChild(body);
    this.element.insertAdjacentHTML('afterbegin',headingHtml);

  }
  createTextElement() {
    this.element = document.createElement('p');
    this.element.classList.add('cnc-heading-availability');
    if (this.isOutletAvailable()) {
      if (this.showQuantity && this.products.length === 1) {
        this.element.innerHTML = `${this.products[0].outletStock} available`;
      } else {
        this.element.innerHTML = 'In stock';
      }
      this.element.classList.add('cnc-heading-available');
    } else {
      this.element.innerHTML = 'Out of stock';
      this.element.classList.add('cnc-heading-unavailable');
    }
  }
}

class OutletContactField extends Renderable {
  constructor(name, id, elementName) {
    super();
    this.name = name;
    this.createElement(id, elementName);
  }
  createElement(id, elementName) {
    this.element = document.createElement('input');
    this.element.type = 'hidden';
    this.element.classList.add('cnc-contact');
    this.element.id = id || `cnc-store-${this.name}`;
    this.element.name = elementName || `attributes[cnc-store-${this.name}]`;
    this.element.value = '';
  }
  getElement() {
    return this.element;
  }
  clear() {
    this.element.value = '';
  }
  setValue(value) {
    this.element.value = value;
  }
}

class Message extends Renderable {
  constructor(value, isError) {
    super();
    this.createElement();
    this.setValue(value);
    this.setIsError(isError);
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.id = 'cnc-message';
    this.paragraph = document.createElement('p');
    this.element.appendChild(this.paragraph);
  }
  getValue() {
    return this.value;
  }
  setValue(value) {
    this.value = value;
    this.paragraph.innerHTML = value;
  }
  clear() {
    this.setValue('');
  }
  setIsError(bool) {
    this.isError = bool;
    if (this.isError) {
      this.element.classList.add('cnc-negative-text');
    } else {
      this.element.classList.remove('cnc-negative-text');
    }
  }
}

class Results extends Renderable {
  constructor(cnc, apiPrefix, subdomain) {
    super();
    this.cnc = cnc;
    this.apiPrefix = apiPrefix;
    this.subdomain = subdomain;
    this.outlets = {};
    this.loaded = false;
    this.lastUpdate = 0;
  }
  update() { }
  fetch() { }
  createElement() {
    this.element = document.createElement('div');
    this.element.id = 'cnc-results';
    this.element.style.display = 'none';
  }
  createList() {
    this.list = document.createElement('ul');
    this.list.id = 'cnc-outlets';
    this.list.classList.add('cart-attribute__field');
    this.element.appendChild(this.list);
  }
  setLocation(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
  getAllOutlets() {
    return this.outlets;
  }
  count() {
    return Object.keys(this.outlets).length;
  }
  unload() {
    this.outlets = [];
    while (this.list.firstChild) {
      this.list.removeChild(this.list.firstChild);
    }
  }
  renderOutlet(outlet) {
    var listItem = document.createElement('li');
    listItem.appendChild(outlet.getElement());
    listItem.appendChild(outlet.getLabel());
    this.list.appendChild(listItem);
  }
  isLoaded() {
    return this.loaded;
  }
  doOutletsExist() {
    return Object.keys(this.outlets).length > 0;
  }
  areOutletsAvailable() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      if (outlet.getAvailability()) {
        return true;
      }
    }
  }
}

class CartResults extends Results {
  constructor(cnc, apiPrefix, subdomain) {
    super(cnc, apiPrefix, subdomain);
    this.createElement();
    this.createInfo();
    this.createList();
    this.variantIds = [];
    this.cartItems = {};
  }
  createInfo() {
    this.info = document.createElement('p');
    this.info.id = 'cnc-info';
    this.element.appendChild(this.info);
  }
  setInfo(value) {
    this.info.innerHTML = value;
  }
  selectNone() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      outlet.deselect();
      this.cnc.updateContactFields();
    }
  }
  selectFirst() {
    if(Object.entries(this.outlets).length > 0){
      if(Object.entries(this.outlets)[0][1].getAvailability() == false){
        $('#btn_checkout').attr('disabled','disabled')
        var stock = Object.entries(this.outlets)[0][1].data.stock;
        for (let [key, value] of Object.entries(stock)){
          if(value - parseInt($('ul[data-id='+key+'] .txtbox').val()) >= 0){
            var headingHtml = `<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>`;
          }else{
            var headingHtml = `<span class="out-of-stock"><i class="fas fa-exclamation-circle"></i> Out of stock</span>`;
          }
          $('ul[data-id='+key+'] .stock-status').html(headingHtml);
        }
      }
    }
    if($("#cnc-results-container").attr('old-data')){
      Object.entries(this.outlets).find(function(outlet){
        if(outlet[1].element.value == $("#cnc-results-container").attr('old-data')){
          outlet[1].select();
          outlet[1].element.click();
        }
      })
    }else{
      $('#cnc-outlets li:first-child .cnc-outlet').click();
    }
    const storeChecked = document.querySelector('#cnc-store-radio:checked')
    const infoInputs = document.querySelectorAll('.cnc-contact')
    const isEmptyResult = document.querySelector('#cnc-outlets').innerHTML === ''
    let hasData = false
    infoInputs.forEach(item => {
      if (item.value !== '') hasData = true
    })
    if (storeChecked && !hasData && !isEmptyResult) {
      // Make sure data not empty when checkout with C&C
      const event = new CustomEvent("updateFieldsClickAndCollect");
      document.dispatchEvent(event);
    }
  }
  getSelectedOutlet() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      if (outlet.isSelected()) {
        return outlet;
      }
    }
  }
  update() {
    if (Date.now() - this.lastUpdate < 1000) {
      return;
    }
    this.lastUpdate = Date.now();
    var parent = this;
    Shopify.getCart(function(cart) {
      var variantIds = [];
      cart.items.forEach(function(item) {
        variantIds.push(item.variant_id);
      });
      parent.cartItems = cart.items;
      parent.variantIds = variantIds;
      parent.fetch();
    });
  }
  fetch() {
    this.unload();
    var parent = this;
    var url = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${this.variantIds.join()}`;
    for (let cartItem of this.cartItems) {
      url += `&qty-${cartItem.variant_id}=${cartItem.quantity}`;
    }
    if (this.latitude && this.longitude) {
      url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
    }
    fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          $('#cnc-outlets').html('')
          for (let outletJson of json.outlets) {
            var outlet = new Outlet(parent.cnc, outletJson, parent.cartItems);
            parent.outlets[outlet.getName()] = outlet;
            parent.renderOutlet(outlet);
          }
          if (json.outlets.length) {
            parent.setInfo('Please choose a pickup location:');
          } else {
            parent.setInfo('');
          }
          parent.loaded = true;
          parent.cnc.updateCollectionAbility();
          parent.cnc.updateCheckoutButton();
          if (parent.cnc.settings.enableMap) {
            parent.cnc.updateMap();
          }
          if (parent.cnc.getMode() === 'store') {
            parent.selectFirst();
          }
        });
  }
}

class ProductResults extends Results {
  constructor(cnc, apiPrefix, subdomain, initialVariantId) {
    super(cnc, apiPrefix, subdomain);
    this.createElement();
    this.createList();
    this.initialVariantId = initialVariantId;
  }
  createElement() {
    this.element = document.createElement('div');
    this.element.id = 'cnc-results';
  }
  update() {
    this.fetch();
  }
  selectFirst() {
    if(Object.entries(this.outlets).length > 0){
      if(Object.entries(this.outlets)[0][1].getAvailability() == false){
        $('#btn_checkout').attr('disabled','disabled')
        var stock = Object.entries(this.outlets)[0][1].data.stock;
        for (let [key, value] of Object.entries(stock)){
          if(value - parseInt($('ul[data-id='+key+'] .txtbox').val()) >= 0){
            var headingHtml = `<span class="in-stock"><i class="fa fa-check-circle"></i> In stock</span>`;
          }else{
            var headingHtml = `<span class="out-of-stock"><i class="fas fa-exclamation-circle"></i> Out of stock</span>`;
          }
          $('ul[data-id='+key+'] .stock-status').html(headingHtml);
        }
      }
    }
    if($("#cnc-results-container").attr('old-data')){
      Object.entries(this.outlets).find(function(outlet){
        if(outlet[1].element.value == $("#cnc-results-container").attr('old-data')){
          outlet[1].select();
          outlet[1].element.click();
        }
      })
    }else{
      $('#cnc-outlets li:first-child .cnc-outlet').click();
    }
  }
  fetch() {
    this.unload();
    var parent = this;
    var variantId = this.findGetParameter('variant');
    if (!variantId) {
      variantId = this.initialVariantId;
    }
    var url = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${variantId}&qty-${variantId}=1`;
    if (this.latitude && this.longitude) {
      url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
    }
    if (isDevSite) {
      const json = data
      for (let outletJson of json.outlets) {
        var outlet = new Outlet(parent.cnc, outletJson, '');
        parent.outlets[outlet.getName()] = outlet;
        parent.renderOutlet(outlet);
      }
      parent.selectFirst();
      return
    }

    fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          $('#cnc-outlets').html("");
          if(json.outlets.length < 1){
            $('#cnc-outlets').html("<p style='color:#8b0000'>Sorry, no pickup locations are available in this area. Please search again!</p>");
          }else {
            for (let outletJson of json.outlets) {
              var outlet = new Outlet(parent.cnc, outletJson, '');
              parent.outlets[outlet.getName()] = outlet;
              parent.renderOutlet(outlet);
            }
            parent.selectFirst();
          }
        })
  }
  getSelectedVariantIdFromHtml() {
    var select = document.getElementById('ProductSelect-product-template');
    if (select) {
      return select.options[select.selectedIndex].value;
    }
  }
  findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
  }
}

async function getSuburbsFromPostcode(postcode) {
  try {
    const response = await fetch(
      `https://habitat-pets-postcode-service.dean-fbf.workers.dev/${postcode}`,
      {
        headers: {
          'Authorization': `Bearer ${POSTCODE_SERVICE_TOKEN}`
        }
      }
    )
    if (!response.ok) {
      throw new Error(`Server responded with ${response.status}`)
    }
    const suburbData = await response.json()
    console.log('suburbData: ', suburbData)
    return suburbData // suburbData should have a 'suburbs' property
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

function getProvinceFromZipCode(zipCode) {
  if (!zipCode) {
    return
  }
  // see list: https://en.wikipedia.org/wiki/Postcodes_in_Australia#Allocation
  let province = ''
  switch (zipCode.substr(0,1)) {
    case '1':
      province = 'New South Wales';
      break
    case '3':
    case '8':
      province = 'Victoria';
      break
    case '4':
    case '9':
      province = 'Queensland';
      break
    case '5':
      province = 'South Australia';
      break
    case '6':
      province = 'Western Australia';
      break
    case '7':
      province = 'Tasmania';
      break
    case '0':
      province = zipCode.slice(1,2) === 2 ? 'Australian Capital Territory' : 'Northern Territory'
      break
    case '2' :
      try {
        zipCode = parseInt(zipCode, 10)
        if (isNaN(zipCode)) {
          return
        }
        province = (zipCode >= 2600 && zipCode <= 2618) || (zipCode >= 2900 && zipCode <= 2920) ? 'Australian Capital Territory' : 'New South Wales'
      } catch (err) {
        console.warn('Could not parse zipcode', err)
      }
      break
    default:
      break
  }
  return province;
}
